
import ScatterPlot from "./ScatterPlot";

const categoryColors = {
  Success: "#117733",
  Excess: "#0072B2",
  Marginal: "#d6cf04",
  Insufficient: "#E69F00",
  Failure: "#661100"
};

export default function WQAnalyteScatterPlot({ data, plotMargin }) {
  return (
    <ScatterPlot
      data={data}
      xAccessor={d => d.inf_thresh_ratio}
      yAccessor={d => d.eff_thresh_ratio}
      xLabel="Inflow Threshold Ratio"
      yLabel="Outflow Threshold Ratio"
      referenceLines={[
        { type: "horizontal", value: 1 },
        { type: "vertical", value: 1, segment: true, yMin: 0, yMax: 1 },
        { type: "diagonal" }
      ]}
      colorAccessor={d => categoryColors[d.category] || "#3182ce"}
      symbolAccessor={d => ({
        shape: "circle",
        fill: d.is_comparison !== 'true'
      })}
      tooltipRenderer={tooltip => (
        <div
          className="absolute z-50 bg-white border border-gray-300 rounded shadow-lg px-3 py-2 text-xs pointer-events-none"
          style={{ left: tooltip.x + 12, top: tooltip.y + 12, minWidth: 180 }}
        >
        {/* To Do: Add event ID to the API response so we can link to the storm event */} 
          <div><b>Category:</b> {tooltip.d.category}</div>
          <div><b>Influent EMC / Threshold:</b> {tooltip.d.inf_thresh_ratio.toFixed(3)}</div>
          <div><b>Effluent EMC / Threshold:</b> {tooltip.d.eff_thresh_ratio.toFixed(3)}</div>
          <div><b>Influent EMC:</b> {tooltip.d.inflow_emc.toFixed(3)}</div>
          <div><b>Effluent EMC:</b> {tooltip.d.outflow_emc.toFixed(3)}</div>
        </div>
      )}
      plotMargin={plotMargin}
    />
  );
} 